var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductivityForMobileToggler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8668 0.799957H6.53343L8.93503 3.20156L6.51317 5.89222L3.7105 3.08956C3.50197 2.88102 3.1649 2.88102 2.95637 3.08956L0.289701 5.75622C0.0811674 5.96476 0.0811674 6.30182 0.289701 6.51036C0.498234 6.71889 0.835301 6.71889 1.04383 6.51036L3.33343 4.22076L6.15637 7.04369C6.2561 7.14396 6.3921 7.19996 6.53343 7.19996C6.68597 7.19996 6.82943 7.13489 6.9297 7.02342L9.6897 3.95676L11.8668 6.13329V0.799957Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityForMobileToggler);
export default __webpack_public_path__ + "static/media/ProductivityForMobileToggler.49d07a04.svg";
export { ForwardRef as ReactComponent };